function escapeCsvValue(value, delimiter = ';') {
  if (value == null) return ''

  let str = String(value)

  if (/^[=+\-@]/.test(str)) {
    str = "'" + str
  }

  str = str.replace(/"/g, '""')

  if (
    str.includes('"') ||
    str.includes('\n') ||
    str.includes('\r') ||
    str.includes(delimiter)
  ) {
    str = `"${str}"`
  }

  return str
}

export function downloadCsv({ filename, fields, data, delimiter = ';' }) {
  const header = (fields || [])
    .map(field => escapeCsvValue(field, delimiter))
    .join(delimiter)

  const rows = (data || []).map(row =>
    (row || []).map(value => escapeCsvValue(value, delimiter)).join(delimiter)
  )

  const csv = [header, ...rows].join('\r\n')
  const bom = '\uFEFF'
  const blob = new Blob([bom + csv], { type: 'text/csv;charset=utf-8;' })

  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
